import { Button, Flex, FormControl, FormLabel, Text, useColorModeValue } from '@chakra-ui/react'
import Card from 'components/Card/Card.js'
import CardBody from 'components/Card/CardBody.js'
import CardHeader from 'components/Card/CardHeader.js'
import { useFormik } from 'formik'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import Select from 'react-select'
import { GET_WORKSHEETS, GET_WORKSHEETS_BY_USER_ID, UPDATE_WORKSHEET_BY_USER } from 'store/worksheets'
import { GET_USER_BY_ID } from 'store/users'

function EditWorksheetUser() {
  const dispatch = useDispatch()
  const history = useHistory()
  const textColor = useColorModeValue('gray.700', 'white')
  const bgColor = useColorModeValue('#FFF', '#718096')
  const hoverColor = useColorModeValue('#CBD5E0', '#4A5568')
  const selectColor = useColorModeValue('#718096', '#1A202C')
  const { id } = useParams()
  const [userName, setUserName] = useState('')

  const customStyles = {
    control: (styles) => ({
      ...styles,
      borderRadius: '15px',
      outline: '2px solid transparent',
      borderColor: '#E2E8F0',
      minHeight: '3rem',
      marginBottom: '24px'
    }),
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isFocused ? hoverColor : state.isSelected ? selectColor : bgColor,
    }),
  }

  const listWorksheet = useSelector((state) => state.worksheets.lists)
  const optionsWorksheet = Object.values(listWorksheet).map((item) => ({
    value: item.id,
    label: item.name
  }))

  const formik = useFormik({
    initialValues: {},
    onSubmit: (values, { setSubmitting }) => {
      const worksheetIds = (values.worksheet_id || []).map((i) => i.value)
      dispatch(UPDATE_WORKSHEET_BY_USER({
        user_id: parseInt(id),
        worksheet_id: worksheetIds
      }))
        .then(() => {
          setSubmitting(false)
          history.push('/admin/users')
        })
        .catch(() => setSubmitting(false))
    }
  })

  const initFetch = useCallback(() => {
    dispatch(GET_WORKSHEETS(''))
    dispatch(GET_USER_BY_ID(id)).then((data) => {
      setUserName(`${data.firstname} ${data.lastname}`)
    })
    dispatch(GET_WORKSHEETS_BY_USER_ID(id)).then((data) => {
      const selected = (data || [])
        .filter(w => !w.is_free)
        .map(w => ({ value: w.worksheet_id, label: w.worksheet_name }))
      formik.setFieldValue('worksheet_id', selected)
    })
  }, [dispatch, id])

  useEffect(() => {
    initFetch()
  }, [initFetch])

  return (
    <Flex direction='column' pt={{ base: '120px', md: '75px' }}>
      <form onSubmit={formik.handleSubmit}>
        <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
          <CardHeader>
            <Flex justify='space-between' align='center' minHeight='60px' w='100%'>
              <Text fontSize='lg' color={textColor} fontWeight='bold'>
                แก้ไขใบงานของ {userName}
              </Text>
            </Flex>
          </CardHeader>
          <CardBody p='20px'>
            <FormControl>
              <FormLabel ms='4px' fontWeight='semibold'>ใบงาน</FormLabel>
              <Select
                isMulti
                id='worksheet_id'
                name='worksheet_id'
                placeholder='เลือกใบงาน'
                options={optionsWorksheet}
                styles={customStyles}
                value={formik.values.worksheet_id || ''}
                onChange={(selected) => {
                  formik.handleChange({ target: { name: 'worksheet_id', value: selected } })
                }}
                onBlur={formik.handleBlur}
              />
              <Button
                type='submit'
                bg='teal.300' fontSize='1rem' color='white' fontWeight='bold'
                w='100%' h='45' mb='24px'
                _hover={{ bg: 'teal.200' }}
                _active={{ bg: 'teal.400' }}
              >
                ตกลง
              </Button>
            </FormControl>
          </CardBody>
        </Card>
      </form>
    </Flex>
  )
}

export default EditWorksheetUser
